import React, { useEffect, useState } from "react";
import { Button, Divider, Input, message, Modal, Spin } from "antd";

import CreateAudienceFilterList from "./audienceFilters/CreateAudienceFilterList";
import AvailableAudienceItem from "./AvailableAudienceItem";

import addCircle from "../../assets/icons/add-circle2.png";
import close from "../../assets/icons/close-circle.svg";
import {
  defaultAge,
  defaultBirthDateRange,
  defaultFirstName,
  defaultGender,
  defaultInsurance,
  defaultJoinedDateRange,
  defaultLastName,
  defaultLocationFilterValue,
  defaultOralHealthScoreRange,
  defaultPatientHistory,
  defaultPaymentAmountRange,
  defaultPaymentCreatedDate,
  defaultPaymentDateRange,
  defaultPaymentPaymentType,
} from "./audienceFilters/defaultFilterValues";
import { controller } from "./controller";
import { isNotEmpty } from "../../utils";

export default function ModalAddCreateAudiences({ 
  showAudienceModal, 
  setShowAudienceModal,
  boardId,
  campaignId,
  selectedAudiences,
  setSelectedAudiences,
  selectedIncludeOrExudeAudiences,
  setSelectedIncludeOrExcludeAudiences,
  getBoardDetails
}) {
  const [createAudienceStep, setCreateAudienceStep] = useState("1");
  const [disableCreateButton, setDisableCreateButton] = useState(false);
  const [scrollFromTop, setScrollFromTop] = useState(0);
  const [isCreatingAudience, setIsCreatingAudience] = useState(false);
  const [audienceSearchName, setAudienceSearchName] = useState("");
  const [audienceName, setAudienceName] = useState("");
  const [loadingAudience, setLoadingAudience] = useState(false);
  const [availableAudiences, setAvailableAudiences] = useState([]);

  // Location
  const [locationFilter, setLocationFilter] = useState({
    name: "",
    city: "",
    state: "",
    country: "",
    latitude: "",
    longitude: "",
  });

  // Oral health
  const [oralHealthFilter, setOralHealthFilter] = useState({ char_value: "", integer_value: undefined });

  // Identification
  const [identificationFilter, setIdentificationFilter] = useState({
    first_name: "",
    last_name: "",
    gender: "",
    age: [0, 0],
    joined_date: { lower: "", upper: "" },
    birth_date: { lower: "", upper: "" },
  });

  // Patient history
  const [patientHistoryFilter, setPatientHistoryFilter] = useState([]);

  // Payment
  const [paymentFilter, setPaymentFilter] = useState({
    payment_method: "",
    payment_plan_amount_range: [0, 0],
    creation_start_date: "",
    creation_end_date: "",
    date_range_start: "",
    date_range_end: "",
  });

  // Insurance
  const [insuranceFilter, setInsuranceFilter] = useState([]);

  async function handleCreateAudiences() {
    if (!audienceName) {
      message.error("Please enter the audience name");
      return;
    }

    try {
      setIsCreatingAudience(true);

      const data = {
        criteria: [],
        method_type: showAudienceModal.type === "included" ? "include" : "exclude",
        title: audienceName,
        branches: [localStorage.getItem("selectedOffice")],
      };

      // First Name
      if (identificationFilter.first_name) {
        data.criteria.push({
          ...defaultFirstName,
          criteria_value: {
            ...defaultFirstName.criteria_value,
            char_value: identificationFilter.first_name,
          },
        });
      }

      // Last Name
      if (identificationFilter.last_name) {
        data.criteria.push({
          ...defaultLastName,
          criteria_value: {
            ...defaultLastName.criteria_value,
            char_value: identificationFilter.last_name,
          },
        });
      }

      // Gender
      if (identificationFilter.gender) {
        data.criteria.push({
          ...defaultGender,
          criteria_value: {
            ...defaultGender.criteria_value,
            char_value: identificationFilter.gender,
          },
        });
      }

      // Age
      if (identificationFilter.age[0] || identificationFilter.age[1]) {
        data.criteria.push({
          ...defaultAge,
          criteria_value: {
            ...defaultAge.criteria_value,
            age_range: {
              lower_age: identificationFilter.age[0],
              upper_age: identificationFilter.age[1],
            },
          },
        });
      }

      // Joined Date
      if (identificationFilter.joined_date.lower || identificationFilter.joined_date.upper) {
        data.criteria.push({
          ...defaultJoinedDateRange,
          criteria_value: {
            ...defaultJoinedDateRange.criteria_value,
            date_range: identificationFilter.joined_date,
          },
        });
      }

      // Birth Date
      if (identificationFilter.birth_date.lower || identificationFilter.birth_date.upper) {
        data.criteria.push({
          ...defaultBirthDateRange,
          criteria_value: {
            ...defaultBirthDateRange.criteria_value,
            date_range: identificationFilter.birth_date,
          },
        });
      }

      console.log(locationFilter);
      // Location
      if (
        locationFilter.name ||
        locationFilter.city ||
        locationFilter.state ||
        locationFilter.country ||
        locationFilter.latitude ||
        locationFilter.longitude
      )
        data.criteria.push({
          ...defaultLocationFilterValue,
          criteria_value: {
            ...defaultLocationFilterValue.criteria_value,
            location: locationFilter,
          },
        });

      // Patient History
      if (patientHistoryFilter.length > 0) {
        patientHistoryFilter.forEach((patientHistory) =>
          data.criteria.push({
            ...defaultPatientHistory,
            criteria_value: {
              value_type: "date_range",
              ...patientHistory,
            },
          })
        );
      }

      // Insurance
      if (insuranceFilter.length > 0) {
        insuranceFilter.forEach((insurance) => {
          data.criteria.push({
            ...defaultInsurance,
            criteria_value: {
              value_type: "char_value",
              ...defaultInsurance.criteria_value,
              ...insurance,
            },
          });
        });
      }

      // Payment
      // Payment method
      if (paymentFilter.payment_method) {
        data.criteria.push({
          ...defaultPaymentPaymentType,
          criteria_value: {
            value_type: "char_value",
            char_value: paymentFilter.payment_method,
          },
        });
      }

      // Amout range
      if (paymentFilter.payment_plan_amount_range[0] !== 0 || paymentFilter.payment_plan_amount_range[1] !== 0) {
        data.criteria.push({
          ...defaultPaymentAmountRange,
          criteria_value: {
            value_type: "integer_value",
            integer_value: paymentFilter.payment_plan_amount_range[0],
            float_value: parseFloat(paymentFilter.payment_plan_amount_range[1]).toFixed(1),
          },
        });
      }

      // Creation date
      if (paymentFilter.creation_start_date || paymentFilter.creation_end_date) {
        data.criteria.push({
          ...defaultPaymentCreatedDate,
          criteria_value: {
            value_type: "date_range",
            date_range: {
              lower: paymentFilter.creation_start_date,
              upper: paymentFilter.creation_end_date,
            },
          },
        });
      }

      // Payment Date Range
      if (paymentFilter.date_range_start || paymentFilter.date_range_end) {
        data.criteria.push({
          ...defaultPaymentDateRange,
          criteria_value: {
            value_type: "date_range",
            date_range: {
              lower: paymentFilter.date_range_start,
              upper: paymentFilter.date_range_end,
            },
          },
        });
      }

      // Oral Health
      if (oralHealthFilter.char_value) {
        data.criteria.push({
          ...defaultOralHealthScoreRange,
          criteria_value: {
            ...defaultOralHealthScoreRange.criteria_value,
            ...oralHealthFilter,
          },
        });
      }

      console.log(data);
      const response = await controller.createAudience(data);
      setCreateAudienceStep("1");
      fetchAvailableAudiences(showAudienceModal.type);
      console.log(response);
    } catch (err) {
      message.error("Something went wrong while creating audiences");
      console.error(err);
    } finally {
      setIsCreatingAudience(false);
    }
  }

  // Check if any filter is defined or not (for handling the `Create` Button).
  useEffect(
    function () {
      const hasPaymentFilter = () => {
        return (
          paymentFilter.payment_method !== "" ||
          paymentFilter.payment_plan_amount_range[0] !== 0 ||
          paymentFilter.payment_plan_amount_range[1] !== 0 ||
          paymentFilter.creation_start_date !== "" ||
          paymentFilter.creation_end_date !== "" ||
          paymentFilter.date_range_start !== "" ||
          paymentFilter.date_range_end !== ""
        );
      };

      const hasIdentificationFilter = () => {
        return (
          identificationFilter.first_name !== "" ||
          identificationFilter.last_name !== "" ||
          identificationFilter.gender !== "" ||
          identificationFilter.age[0] !== 0 ||
          identificationFilter.age[1] !== 0 ||
          identificationFilter.joined_date.lower !== "" ||
          identificationFilter.joined_date.upper !== "" ||
          identificationFilter.birth_date.lower !== "" ||
          identificationFilter.birth_date.upper !== ""
        );
      };

      console.log(patientHistoryFilter);

      const isAnyFilterSet =
        Object.values(locationFilter).some((value) => value !== "") ||
        oralHealthFilter.char_value !== "" ||
        oralHealthFilter.integer_value !== undefined ||
        hasIdentificationFilter() ||
        patientHistoryFilter.length > 0 ||
        insuranceFilter.length > 0 ||
        hasPaymentFilter();

      setDisableCreateButton(!isAnyFilterSet);
    },

    [locationFilter, oralHealthFilter, identificationFilter, patientHistoryFilter, insuranceFilter, paymentFilter]
  );

  const handleAddAudience = async () => {
    try {
      console.log("selectedAudiences", selectedAudiences)
      const selectorsToSend = { campaign: { id: campaignId, audience_selectors: selectedAudiences.map(s => s.id ? s.id : s) }};
      setLoadingAudience(true);
      const response = await controller.addAudiencSelectorsToBoard(boardId, selectorsToSend);
      getBoardDetails && getBoardDetails();
      handleCloseModal();
    } catch (err) {
      message.error("We could not fetch Audience selectors");
      console.error("", err);
    } finally {
      setLoadingAudience(false);
    }
  };

  const fetchAvailableAudiences = async (type) => {
    try {
      setLoadingAudience(true);
      const response = await controller.getAudienceSelectorsByOfficeId(type.slice(0, -1));
      console.log('AvailableAudiences', response.json);
      const filteredAvailableAudiences = response.json.filter(available => 
        !selectedAudiences.some(selected => selected.id ? selected.id === available.id : selected === available.id)
      );
      setAvailableAudiences(filteredAvailableAudiences);
    } catch (err) {
      message.error("We could not fetch Audience selectors");
      console.error("", err);
    } finally {
      setLoadingAudience(false);
    }
  };

  // Fetch audiences when modal opens
  useEffect(() => {
    if (showAudienceModal.show) {
      fetchAvailableAudiences(showAudienceModal.type);
    }
  }, [showAudienceModal.show]);

  const handleCloseModal = () => {
    setShowAudienceModal({ type: "", show: false });
    setCreateAudienceStep("1");
    setAudienceSearchName("");
    setAudienceName("");
    // Reset filters when closing modal
    setLocationFilter({
      name: "", city: "", state: "", country: "", latitude: "", longitude: ""
    });
    setOralHealthFilter({ char_value: "", integer_value: undefined });
    setIdentificationFilter({
      first_name: "", last_name: "", gender: "", age: [0, 0], 
      joined_date: { lower: "", upper: "" }, birth_date: { lower: "", upper: "" }
    });
    setPatientHistoryFilter([]);
    setInsuranceFilter([]);
    setPaymentFilter({
      payment_method: "", payment_plan_amount_range: [0, 0],
      creation_start_date: "", creation_end_date: "", date_range_start: "", date_range_end: ""
    });
  };

  return (
    <Modal
      title={`Add ${showAudienceModal.type[0].toUpperCase() + showAudienceModal.type.slice(1)} Audience`}
      open={showAudienceModal.show}
      onCancel={() => setShowAudienceModal({ type: "", show: false })}
      style={{ padding: 10 }}
      width={900}
      closeIcon={<img src={close} alt="close" />}
      footer={
        createAudienceStep === "1" ? (
          <Button type="primary" style={{ width: "50%", padding: "20px", fontSize: 16, marginTop: 20 }} onClick={() => handleAddAudience(boardId)}>
            Save
          </Button>
        ) : (
          <Button
            type="primary"
            style={{ width: "100%", padding: "20px", fontSize: 16, marginTop: 20 }}
            onClick={handleCreateAudiences}
            disabled={disableCreateButton}
            loading={isCreatingAudience}
          >
            Create
          </Button>
        )
      }
    >
      {createAudienceStep === "1" ? (
        <div>
          <p style={{ fontSize: 14, marginBottom: 20, color: "#848696" }}>
            You can add audience from available audiences or create new
          </p>

          <div style={{ display: "flex", alignItems: "start", gap: 20 }}>
            {/* First column */}
            <div style={{ width: "50%" }}>
              <p style={{ fontSize: 18 }}>Available Audience</p>

              <Input
                type="text"
                placeholder="Enter Audience Name"
                style={{ borderRadius: 7, border: "1px solid #6B43B5", marginBottom: 15 }}
                onChange={(e) => setAudienceSearchName(e.target.value)}
                value={audienceSearchName}
              />

              {/* Available Audiences */}
              <div>
                <div
                  style={{ display: "flex", flexDirection: "column", gap: 15, height: 500, overflowY: "auto" }}
                  onScrollCapture={(e) => setScrollFromTop(e.target.scrollTop)}
                  className="custom-scroll"
                >
                  {loadingAudience ? 
                    <Spin style={{marginTop: 24}}/> 
                  :
                    isNotEmpty(availableAudiences) && availableAudiences.map((audience) => (
                      <AvailableAudienceItem
                        key={audience.id}
                        audience={audience}
                        availableAudiences={availableAudiences}
                        setAvailableAudiences={setAvailableAudiences}
                        selectedAudiences={selectedAudiences}
                        setSelectedAudiences={setSelectedAudiences}
                        includeOrExcludeAudiences={selectedIncludeOrExudeAudiences}
                        setSelectedIncludeOrExcludeAudiences={setSelectedIncludeOrExcludeAudiences}
                        scrollFromTop={scrollFromTop}
                      />
                    ))
                  }
                </div>

                <Button
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 5,
                    width: "100%",
                    border: "1px solid #6b43B5",
                    color: "#6b43B5",
                    padding: "20px 0",
                    borderRadius: 10,
                    marginTop: 20,
                  }}
                  onClick={() => setCreateAudienceStep("2")}
                >
                  <img src={addCircle} alt="plus" />
                  Create Audience
                </Button>
              </div>
            </div>

            {/* Selected Audiences */}
            <div style={{ width: "50%" }}>
              <p style={{ fontSize: 18, textTransform: "capitalize" }}>
                Selected {showAudienceModal.type} Audience
              </p>
              <div
                style={{
                  backgroundColor: "#F6F5FD",
                  padding: 20,
                  border: "1px solid #E0DDF7",
                  borderRadius: 10,
                }}
              >
                <p style={{ color: "#848696", marginBottom: 10 }}>Add from Available Audience</p>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 10,
                    height: 544,
                    overflowY: "auto",
                  }}
                  className="custom-scroll"
                >
                  {isNotEmpty(selectedIncludeOrExudeAudiences) && selectedIncludeOrExudeAudiences.map((audience) => (
                    <AvailableAudienceItem
                      key={audience.id}
                      audience={audience}
                      selected={true}
                      availableAudiences={availableAudiences}
                      setAvailableAudiences={setAvailableAudiences}
                      selectedAudiences={selectedAudiences}
                      setSelectedAudiences={setSelectedAudiences}
                      includeOrExcludeAudiences={selectedIncludeOrExudeAudiences}
                      setSelectedIncludeOrExcludeAudiences={setSelectedIncludeOrExcludeAudiences}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <CreateAudienceFilterList
          showAudienceModal={showAudienceModal}
          setCreateAudienceStep={setCreateAudienceStep}
          setAudienceName={setAudienceName}
          audienceName={audienceName}
          // Location
          setLocationFilter={setLocationFilter}
          locationFilter={locationFilter}
          // Oral Health
          setOralHealthFilter={setOralHealthFilter}
          oralHealthFilter={oralHealthFilter}
          // Identification
          identificationFilter={identificationFilter}
          setIdentificationFilter={setIdentificationFilter}
          // Patient History
          setPatientHistoryFilter={setPatientHistoryFilter}
          patientHistoryFilter={patientHistoryFilter}
          // Insurance
          setInsuranceFilter={setInsuranceFilter}
          insuranceFilter={insuranceFilter}
          // Payment
          setPaymentFilter={setPaymentFilter}
          paymentFilter={paymentFilter}
        />
      )}
    </Modal>
  );
}